// extracted by mini-css-extract-plugin
export default {"container":"Tickets_container__U3ZXE"};